export const DEFAULT_OPERATOR = 'equals';
export const EXAMPLE_OPERATOR_OPTIONS = [
    { value: 'equals', label: 'equals' },
    { value: 'does not equal', label: 'does not equal' },
    { value: 'contains', label: 'contains' },
    { value: 'does not contain', label: 'does not contain' },
    { value: 'starts with', label: 'starts with' },
    { value: 'ends with', label: 'ends with' },
    { value: 'does not start with', label: 'does not start with' },
    { value: 'does not end with', label: 'does not end with' },
];
export const EXAMPLE_OPTIONS = [
    { value: '1Plusads', label: '1Plusads label' },
    { value: '24Met Fraudshield', label: '24Met Fraudshield' },
    { value: '360 Ads', label: '360 Ads' },
    { value: '3dpop', label: '3dpop' },
    { value: '19Mobi', label: '19Mobi' },
    { value: 'Facebook', label: 'Facebook' },
    { value: 'Twitter', label: 'Twitter' },
    { value: 'Tiktok', label: 'Tiktok' },
    { value: 'Google', label: 'Google' },
    { value: 'Apple', label: 'Apple' },
];
export const EXAMPLE_OPTIONS_CAMPAIGN = new Array(1000)
    .fill('')
    .map((_, i) => ({
    value: `${i + 1}`,
    label: `Campaign ${i + 1}`,
}));
//# sourceMappingURL=LightweightFilterMenu.constants.js.map